import { useTranslation } from '@/i18n/useTranslation';

import type { StaticMessageKey } from '@/i18n/messages';
import { NavLink } from 'react-router-dom';
import { useAuth } from '@/auth/useAuth';

interface NavItem {
  to: string;
  label: StaticMessageKey;
  caption: StaticMessageKey;
  icon: string;
  end?: boolean;
}

const NAV_ITEMS: NavItem[] = [
  { to: '/', label: 'Dashboard', caption: 'Overview', icon: '01', end: true },
  { to: '/logs', label: 'Inspections', caption: 'Saved scans & review', icon: '02' },
  { to: '/analytics', label: 'Analytics', caption: 'Scans & corrections', icon: '03' },
  { to: '/exports', label: 'Export Center', caption: 'Saved inspection exports', icon: '04' },
];

const ADMIN_NAV_ITEMS: NavItem[] = [
  {
    to: '/admin/review-categories',
    label: 'Review Categories',
    caption: 'Correction choices',
    icon: 'A2',
  },
  { to: '/admin/audit-log', label: 'Audit Log', caption: 'System activity', icon: 'A3' },
];

export function Sidebar() {
  const { t } = useTranslation();
  const { role } = useAuth();

  return (
    <nav className="app-sidebar" aria-label={t('Primary')}>
      <div className="app-sidebar__brand">
        <img src="/sanwa-kenko-logo.png" alt={t('Sanwa Kenko')} className="app-sidebar__logo" />
        <span className="app-sidebar__product">{t('Quality Operations Portal')}</span>
      </div>
      <div className="app-sidebar__section-label">{t('Operations')}</div>
      <ul className="stack">
        {NAV_ITEMS.map((item) => (
          <li key={item.to}>
            <NavLink
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `app-sidebar__link${isActive ? ' app-sidebar__link--active' : ''}`
              }
            >
              <span className="app-sidebar__link-index" aria-hidden="true">
                {item.icon}
              </span>
              <span>
                <strong>{t(item.label)}</strong>
                <small>{t(item.caption)}</small>
              </span>
            </NavLink>
          </li>
        ))}
      </ul>

      {(role === 'admin' || role === 'super_admin') && (
        <>
          <div className="app-sidebar__section-label">{t('Administration')}</div>
          <ul className="stack">
            {role === 'super_admin' && (
              <li>
                <NavLink
                  to="/admin/users"
                  className={({ isActive }) =>
                    `app-sidebar__link${isActive ? ' app-sidebar__link--active' : ''}`
                  }
                >
                  <span className="app-sidebar__link-index" aria-hidden="true">
                    A1
                  </span>
                  <span>
                    <strong>{t('Users')}</strong>
                    <small>{t('Access management')}</small>
                  </span>
                </NavLink>
              </li>
            )}
            {ADMIN_NAV_ITEMS.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  className={({ isActive }) =>
                    `app-sidebar__link${isActive ? ' app-sidebar__link--active' : ''}`
                  }
                >
                  <span className="app-sidebar__link-index" aria-hidden="true">
                    {item.icon}
                  </span>
                  <span>
                    <strong>{t(item.label)}</strong>
                    <small>{t(item.caption)}</small>
                  </span>
                </NavLink>
              </li>
            ))}
          </ul>
        </>
      )}
    </nav>
  );
}
